import { API_BASE } from '../config';
import { getAuthToken } from '../utils/authStorage';

// Helper function to get auth headers
const authHeaders = async () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No authentication token found');
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Get activity logs with filters
export async function getActivityLogs(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.offset !== undefined) queryParams.append('offset', params.offset);
  if (params.limit !== undefined) queryParams.append('limit', params.limit);
  if (params.user_id) queryParams.append('user_id', params.user_id);
  if (params.action) queryParams.append('action', params.action);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);
  
  const url = `${API_BASE}/activity-logs/?${queryParams.toString()}`;
  const res = await fetch(url, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch activity logs');
  }
  
  return res.json();
}

// Get a specific activity log by ID
export async function getActivityLog(logId) {
  const res = await fetch(`${API_BASE}/activity-logs/${logId}`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch activity log');
  }
  
  return res.json();
}

// Update activity log note
export async function updateActivityLogNote(logId, note) {
  const res = await fetch(`${API_BASE}/activity-logs/${logId}/note`, {
    method: 'PUT',
    headers: await authHeaders(),
    body: JSON.stringify({ note })
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to update activity log note');
  }
  
  return res.json();
}

// Get recent activity logs
export async function getRecentActivityLogs(limit = 20) {
  const res = await fetch(`${API_BASE}/activity-logs/recent?limit=${limit}`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch recent activity logs');
  }
  
  return res.json();
}

// Get activity logs by user
export async function getActivityLogsByUser(userId, limit = 50) {
  const res = await fetch(`${API_BASE}/activity-logs/user/${userId}?limit=${limit}`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch user activity logs');
  }
  
  return res.json();
}

// Get activity logs by action
export async function getActivityLogsByAction(action, limit = 50) {
  const res = await fetch(`${API_BASE}/activity-logs/action/${action}?limit=${limit}`, {
    headers: await authHeaders()
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch activity logs by action');
  }
  
  return res.json();
}
